import { FormControlLabel } from '@mui/material'
import React, { memo } from 'react'

import CustomSwitch from '../forms/customElements/CustomSwitch'

const SwitchControl = ({
  leftLabel,
  rightLabel,
  checked,
  onChange,
  disabled
}) => {
  const handleChange = ({ target }) => {
    onChange(target.checked)
  }
  return (
    <>
      <FormControlLabel control={<></>} label={leftLabel} sx={{ ml: 0 }} />
      <FormControlLabel
        control={
          <CustomSwitch
            checked={checked}
            color='primary'
            disabled={disabled}
            onChange={handleChange}
          />
        }
        label={rightLabel}
        sx={{ mr: 0 }}
      />
    </>
  )
}

export default memo(SwitchControl)
